export enum DocumentTypeEnum {
  Passport = 0,
  NationalID = 1,
  DriversLicense = 2,
  SocialSecurityNumber = 3,
  TaxIdNumber = 4,
  CPF = 5,
  CNPJ = 6,
}

export const documentTypeList = [
  { label: "passport", value: DocumentTypeEnum.Passport },
  { label: "nationalID", value: DocumentTypeEnum.NationalID },
  { label: "driversLicense", value: DocumentTypeEnum.DriversLicense },
  {
    label: "socialSecurityNumber",
    value: DocumentTypeEnum.SocialSecurityNumber,
  },
  { label: "taxIdNumber", value: DocumentTypeEnum.TaxIdNumber },
];
